import {dataTestId} from '@hconnect/uikit'
import {Grid, Skeleton} from '@mui/material'

import {useHistoryMaterialsById} from '../../../../shared/hooks/api/materials/useHistoryMaterialsById'
import {usePlanningChartStartEnd} from '../../../page-planning/dailyPlanning/PlanningChartStartEndProvider'
import {OptimizerStockLevelIndicator} from '../OptimizerStockLevelIndicator'
import {useGetOptimizedMaterialIds} from '../utils/useGetOptimizedMaterialIds'

const getSiloLevelsSkeletons = (amount: number) => {
  return Array.from({length: amount}, (_, index) => (
    <Grid item xs={12} md={6} key={index}>
      <Skeleton variant="rectangular" />
    </Grid>
  ))
}

export const OptimizerStockLevelsSummary = () => {
  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()
  const {data: materialsById} = useHistoryMaterialsById({timeFrame: [startOfPlan, endOfPlan]})

  const optimizedMaterialIds = useGetOptimizedMaterialIds()

  const shouldShow = materialsById && optimizedMaterialIds

  return (
    <>
      <Grid container spacing={4} mt={1} {...dataTestId('optimizer_stock_levels_summary')}>
        {shouldShow && optimizedMaterialIds !== undefined
          ? optimizedMaterialIds.map((materialId, index) => (
              <Grid
                item
                xs={12}
                md={6}
                key={`${materialId}_${index}_card`}
                {...dataTestId(`optimizer_stock_levels_${materialId}`)}
              >
                <OptimizerStockLevelIndicator material={materialsById[materialId]} />
              </Grid>
            ))
          : getSiloLevelsSkeletons(6)}
      </Grid>
    </>
  )
}
